"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var store_1 = require("../../store");
var Permission_1 = require("../Permission");
var Forbidden_1 = __importDefault(require("../../views/Forbidden"));
var Content = antd_1.Layout.Content;
var SimpleView = function (props) {
    var children = props.children;
    var guide = store_1.useStore(function (state) { return state.ui.guide; });
    return (react_1.default.createElement(antd_1.Layout, { className: "ant-app-simple-layout" },
        react_1.default.createElement(Content, { className: "ant-app-details-area" }, children),
        guide));
};
exports.default = Permission_1.withPermission(SimpleView, react_1.default.createElement(Forbidden_1.default, null));
